/**
 * Updates countdown and returns minutes & seconds
 * @param {string} defaultTimeValue - Time value for countdown
 * @param {dw.util.Date} orderCreationDate - order creation Date
 * @returns {Object} - a JSON object with minutes & seconds
 */
function returnTimer(defaultTimeValue, orderCreationDate) {
    var timerVal = 0;
    var currentDate = new Date();
    var creationDate = new Date(orderCreationDate);
    creationDate.setMinutes(creationDate.getMinutes() + Math.abs(defaultTimeValue));
    var diffOfTimes = creationDate - currentDate;
    var dateToMin = Math.floor(diffOfTimes / 60000);
    var dateToSec = parseInt(((diffOfTimes % 60000) / 1000).toFixed(0), 0);
    var minAndSec = `${dateToMin}:${dateToSec < 10 ? '0' + dateToSec : dateToSec}`;
    timerVal = creationDate.getTime() >= currentDate.getTime() ? minAndSec : timerVal;
    return timerVal;
}

module.exports = returnTimer;
